







import Vue from 'vue'

export default Vue.extend({
  name: 'GoogleDriveAuthSuccess',

  metaInfo(): any {
    return {
      title: 'DoneDone2 - Google Drive Authentication',
    }
  },

  data() {
    return {
      email: '',
      token: '',
      gerror: '',
    }
  },

  created() {
    const routeParams =
      this.$route && this.$route.query ? this.$route.query : ''

    if (routeParams) {
      if (routeParams.gemail) {
        this.email = routeParams.gemail
      }
      if (routeParams.gat) {
        this.token = routeParams.gat
      }
      if (routeParams.gerror) {
        this.gerror = routeParams.gerror
      }

      if (routeParams.gerror) {
        this.gerror = routeParams.gerror
      }

      window.localStorage.setItem(
        'googleAuth',
        JSON.stringify({
          email: this.email,
          apiAuthToken: this.token,
          gerror: this.gerror,
        }),
      )
      window.close()
    }
  },
})
